import imageOne from "../../assets/IMG_3958.webp";
import imageTwo from "../../assets/IMG_4758.webp";
import imageThree from "../../assets/skull4.webp";
import imageFour from "../../assets/IMG_4782.webp";
import imageFive from "../../assets/bobcat.webp";
import skull from "../../assets/skull.png";
import plaque from "../../assets/plaque.png";
import antlers from "../../assets/antlers.png";
import logo from "../../assets/logo-transparent.png";
import { useNavigate } from "react-router-dom";
import './Home.css';

export default function Home() {
    const navigate = useNavigate();

    const services = [
        {
            icon: skull,
            title: 'European Mounts',
            description: 'Professional European mounts for deer, bobcats, coyotes and other species with expert cleaning and whitening.',
        },
        {
            icon: plaque,
            title: 'Display Plaques',
            description: 'Handcrafted wooden plaques for your trophy to be mounted on.',
        },
        {
            icon: antlers,
            title: 'Antler Mounts',
            description: 'Display your sheds with a velvet cap or replica skull.',
        },
    ];
    const process = [
        {
        number: 1,
        title: 'Drop Off',
        description: 'Bring your skull to us or schedule a meetup. We accept skulls in any condition.',
        },
        {
        number: 2,
        title: 'Gentle Cleaning',
        description: 'We carefully simmer, clean, and degrease the skull for optimal results.',
        },
        {
        number: 3,
        title: 'Whitening Process',
        description: 'Your mount can be left natural or whitened to a brilliant finish while preserving bone integrity and antler color.',
        },
        {
        number: 4,
        title: 'Mounting & Finishing',
        description: 'If desired, we can mount your trophy on a handmade plaque with your choice of wood species and finish.',
        },
    ];

    const handleCardHover = (e) => {
        e.currentTarget.style.transform = 'translateY(-8px)';
    };

    const handleCardLeave = (e) => {
        e.currentTarget.style.transform = 'none';
    };

    const handleImageHover = (e) => {
        e.currentTarget.style.transform = 'scale(1.05)';
    };

    const handleImageLeave = (e) => {
        e.currentTarget.style.transform = 'scale(1)';
    };

    return (
        <div className="">
            <section className="hero">
                <div className="heroContent">
                    <h1 className="heroTitle">Gulgoleth Mounts</h1>
                    <img src={logo} alt="Logo" className="heroImage" />
                    <p className="heroSubtitle">Preserving Your Hunting Memories with Quality European Mounts</p>
                </div>
            </section>
            <section className="section">
                <h2 className="section-title">Services</h2>
                <div className="grid">
                    {services.map((service) => (
                        <div
                            key={service.title}
                            className="card"
                            onMouseEnter={handleCardHover}
                            onMouseLeave={handleCardLeave}
                        >
                            <div className="cardIcon"><img className="cardIconImage" src={service.icon} alt="" /></div>
                            <h3 className="cardTitle">{service.title}</h3>
                            <p className="cardText">{service.description}</p>
                        </div>
                    ))}
                </div>
            </section>
            <section /*style={{ ...section, ...processSection }}*/>
                <h2 className="sectionTitle">Our Process</h2>
                <div className="processSteps">
                {process.map((step) => (
                    <div key={step.number} className="step">
                    <div className="stepNumber">{step.number}</div>
                    <div className="stepContent">
                        <h3 className="stepTitle">{step.title}</h3>
                        <p className="stepText">{step.description}</p>
                    </div>
                    </div>
                ))}
                </div>
            </section>
            <section className="sectionDark">
            <h2 /*style={{ ...styles.sectionTitle, ...styles.sectionTitleLight }}*/>
            Our Work
            </h2>
            <div className="gallery">
                <img
                    src={imageOne}
                    alt="European mount example 1"
                    className="galleryImage"
                    onMouseEnter={handleImageHover}
                    onMouseLeave={handleImageLeave}
                />
                <img
                    src={imageTwo}
                    alt="European mount example 2"
                    className="galleryImage"
                    onMouseEnter={handleImageHover}
                    onMouseLeave={handleImageLeave}
                />
                <img
                    src={imageThree}
                    alt="European mount example 3"
                    className="galleryImage"
                    onMouseEnter={handleImageHover}
                    onMouseLeave={handleImageLeave}
                />
                <img
                    src={imageFour}
                    alt="European mount example 4"
                    className="galleryImage"
                    onMouseEnter={handleImageHover}
                    onMouseLeave={handleImageLeave}
                />
                <img
                    src={imageFive}
                    alt="Bobcat"
                    className="galleryImage"
                    onMouseEnter={handleImageHover}
                    onMouseLeave={handleImageLeave}
                />
            </div>
        </section>
        <section className="ctaSection">
        <h2 className="ctaSectionTitle">Ready to Preserve Your Trophy?</h2>
        <p className="ctaSectionText">
          Contact us today for a free quote. We offer competitive pricing and
          fast turnaround times for all European mount services.
        </p>
        <button className="ctaButton" onClick={() => navigate('/contact')}>
            Contact Us
        </button>
      </section>
        </div>
    );
}